import { Component, Input, OnInit } from '@angular/core';
import { IcpCarouselModel } from './carousel-images.model';

@Component({
  selector: 'icp-carousel',
  templateUrl: './icp-carousel.component.html',
  styleUrls: ['./icp-carousel.component.scss'],
})
export class IcpCarouselComponent implements OnInit {
  @Input() images: Array<IcpCarouselModel>;
  @Input() timeBetween: number = 4000;
  @Input() smallCaption: boolean = false;

  ciclingImages: boolean;
  ciclingCaptions: boolean;
  animationDuration: number = 1000;

  activeItem: number = 0;
  activeImage: number = 0;
  activeCaption: number = 0;

  constructor() {}

  ngOnInit() {
    if (this.images.length > 1) {
      this.cicleCarousel();
    }
  }

  cicleCarousel() {
    setTimeout(() => {
      this.activeItem === this.images.length - 1
        ? (this.activeItem = 0)
        : this.activeItem++;
      this.animateImages();
      this.animateCaptions();
      this.cicleCarousel();
    }, this.timeBetween);
  }

  animateImages() {
    this.ciclingImages = true;

    setTimeout(() => {
      this.activeImage === this.images.length - 1
        ? (this.activeImage = 0)
        : this.activeImage++;
      this.ciclingImages = false;
    }, this.animationDuration - 10);
  }

  animateCaptions() {
    this.ciclingCaptions = true;

    setTimeout(
      () => {
        this.activeCaption === this.images.length - 1
          ? (this.activeCaption = 0)
          : this.activeCaption++;
        this.ciclingCaptions = false;
      },
      this.animationDuration / 2 - 1
    );
  }
}
